<template>
  <div class="container colab" id="colab">
    <div class="row shadow rounded align-items-center vh-100 gx-5">
      <div class="col-12 col-md-6 text-center">
        <div class="">
          <p class="display-5 fw-bold text-primary">Team Up !</p>
          <h3 class="my-5">Interest to collaborate with me?</h3>
          <div>
            <p class="my-3">Just leave your email and message here.</p>

            <!-- noti -->

            <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
              <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
              </symbol>
            </svg>
            <div class="alert alert-success d-flex align-items-center" role="alert" v-if="showSuccess">
              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill" /></svg>
              <div>Thank you for contacting me.</div>
            </div>

            <!-- endNoti -->

            <form @submit.prevent="addData">
              <div class="mb-3">
                <input required v-model="email" type="email" placeholder="example@john.doe" class="form-control blur p-3" />
                <small class="small text-danger" v-if="errors.email">Please enter email address.</small>
              </div>
              <div class="mb-3">
                <textarea required v-model="message" class="w-100 form-control blur" rows="5" placeholder="Hello..."></textarea>
                <small class="small text-danger" v-if="errors.message">Please enter messages.</small>
              </div>
              <div class="mb-">
                <button class="btn btn-outline-primary w-50">
                  Send
                  <span class="spinner-grow spinner-grow-sm ms-3" role="status" aria-hidden="true" v-if="isUploading"></span>
                  <i class="bi bi-send ms-3" v-else></i>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-none d-md-block">
        <img src="../assets/photo/colab/Group44.png" class="w-100" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { initializeApp } from "firebase/app";
import { addDoc, collection, getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyDptdsdD3s_KsITzhf3JaaoCETcD2u4QLA",
  authDomain: "portfolio-38259.firebaseapp.com",
  projectId: "portfolio-38259",
  storageBucket: "portfolio-38259.appspot.com",
  messagingSenderId: "865109724539",
  appId: "1:865109724539:web:4610fcd903e5a4d67241de",
};
const app = initializeApp(firebaseConfig);
let db = getFirestore(app);

export default {
  setup() {
    let email = ref("");
    let message = ref("");
    let errors = ref({
      email: null,
      message: null,
    });
    let isUploading = ref(false);
    let showSuccess = ref(false);

    let addData = async () => {
      if (email.value == "") {
        errors.value.email = true;
        return;
      } else {
        errors.value.email = null;
      }
      if (message.value == "") {
        errors.value.message = true;
        return;
      } else {
        errors.value.message = null;
      }
      isUploading.value = true;

      let addData = await addDoc(collection(db, "messages"), {
        email: email.value,
        message: message.value,
      });
      email.value = "";
      message.value = "";

      isUploading.value = false;
      showSuccess.value = true;
      console.log(addData);
    };

    return { email, message, addData, isUploading, errors, showSuccess };
  },
};
</script>

<style lang="scss" scoped></style>
